export const LOCAL_WORKBOOK_URL = './report-data/Aqara_日本达人资源数据底表_20260722.xlsx'

export const navSections = [
  { id: 'overview', label: '总览' },
  { id: 'pool', label: '资源池' },
  { id: 'history', label: '历史合作' },
  { id: 'j200', label: 'J200' },
  { id: 'cases', label: '优秀案例' },
  { id: 'creators', label: '后期合作资源' },
  { id: 'head', label: '头部达人' },
  { id: 'appendix', label: '附录' },
]

export const reportMeta = {
  title: 'Aqara 日本达人资源盘点',
  period: '2024—2026',
  updatedAt: '2026.07.22',
  note: '资源池按达人身份去重，来源包括历史有记录的在库达人，以及通过 NoxInfluencer 从日本地区 YouTube、Instagram、TikTok 按智能门锁、智能家居、Apple 生态与生活方式主题初筛的外部达人。历史合作达人 88 位（2024—2025 去重），J200 当前合作 37 位（2026）。',
}

export const overviewMetrics = [
  { id: 'total', label: '达人资源总量', value: 710, note: '历史记录资源 + 外部可发掘', target: '#pool' },
  { id: 'internal', label: '在库达人', value: 113, note: '历史记录资源', target: '#pool' },
  { id: 'external', label: '外部初筛达人', value: 597, note: '第三方平台筛选', target: '#pool' },
  { id: 'history', label: '历史合作', value: 88, note: '2024—2025 去重', target: '#history' },
  { id: 'j200', label: 'J200 当前合作', value: 37, note: '众筹 + 上市期', target: '#j200', accent: true },
]

export const poolData = {
  counts: {
    internalCreators: 113,
    externalPlatformAccounts: 666,
    externalDedupedCreators: 637,
    externalMatchedInternal: 40,
    externalNewCreators: 597,
    combinedDedupedCreators: 710,
  },
  platforms: {
    external: {
      eyebrow: '666 个外部平台账号',
      note: '外部资源采用平台账号口径；跨平台账号在身份总量中会合并。',
      items: [
        { label: 'Instagram', value: 236, share: 35.4, color: '#e60012' },
        { label: 'YouTube', value: 223, share: 33.5, color: '#1d1d1f' },
        { label: 'TikTok', value: 207, share: 31.1, color: '#8e8e93' },
      ],
    },
    internal: {
      eyebrow: '113 位在库资源',
      note: '在库资源按达人主平台统计；历史合作以 YouTube 为主，媒体／博客及未标注账号合并为其他。',
      items: [
        { label: 'YouTube', value: 100, share: 88.5, color: '#e60012' },
        { label: 'Instagram', value: 7, share: 6.2, color: '#1d1d1f' },
        { label: '其他／媒体', value: 5, share: 4.4, color: '#8e8e93' },
        { label: 'TikTok', value: 1, share: 0.9, color: '#d2d2d7' },
      ],
    },
  },
  creatorTypes: {
    external: {
      eyebrow: '637 位外部身份',
      centerValue: '637',
      centerLabel: '外部身份',
      note: '基于主页与内容标签自动互斥初分，后续合作前仍需人工复核。',
      items: [
        { label: '智能家居／门锁', value: 239, share: 37.5, color: '#e60012' },
        { label: '家居生活／DIY', value: 161, share: 25.3, color: '#1d1d1f' },
        { label: 'Apple／数码', value: 157, share: 24.6, color: '#8e8e93' },
        { label: '其他／待复核', value: 80, share: 12.6, color: '#d2d2d7' },
      ],
    },
    internal: {
      eyebrow: '113 位在库资源',
      centerValue: '113',
      centerLabel: '在库资源',
      note: '结合既有 Apple 证据、Nox 主页标签与近期内容复核；接口缺失项以公开主页补证，仅 2 位跨品类账号保留为其他。',
      items: [
        { label: '智能家居／门锁', value: 7, share: 6.2, color: '#e60012' },
        { label: '家居生活／DIY', value: 30, share: 26.5, color: '#1d1d1f' },
        { label: 'Apple／数码', value: 74, share: 65.5, color: '#8e8e93' },
        { label: '其他／待复核', value: 2, share: 1.8, color: '#d2d2d7' },
      ],
    },
  },
  followerTiers: {
    all: {
      eyebrow: '710 位全部资源',
      centerValue: '710',
      centerLabel: '全部资源',
      note: '全部资源按在库关系 113 位与外部新增 597 位合并计算，已排除跨池重复。',
      items: [
        { label: '5千–5万', value: 227, share: 32.0, color: '#e60012' },
        { label: '5万–30万', value: 206, share: 29.0, color: '#1d1d1f' },
        { label: '30万–100万', value: 167, share: 23.5, color: '#8e8e93' },
        { label: '100万+', value: 96, share: 13.5, color: '#b5b5ba' },
        { label: '5千以下／未知', value: 14, share: 2.0, color: '#d2d2d7' },
      ],
    },
    internal: {
      eyebrow: '113 位在库资源',
      centerValue: '113',
      centerLabel: '在库资源',
      note: '在库资源中 8 位低于 5 千粉丝、6 位粉丝量待补，合并显示为“5千以下／未知”。',
      items: [
        { label: '5千–5万', value: 45, share: 39.8, color: '#e60012' },
        { label: '5万–30万', value: 46, share: 40.7, color: '#1d1d1f' },
        { label: '30万–100万', value: 7, share: 6.2, color: '#8e8e93' },
        { label: '100万+', value: 1, share: 0.9, color: '#b5b5ba' },
        { label: '5千以下／未知', value: 14, share: 12.4, color: '#d2d2d7' },
      ],
    },
  },
  apple: [
    { label: '在库达人', value: 25, total: 113, share: 22.1, color: '#e60012' },
    { label: '外部初筛达人', value: 44, total: 597, share: 7.4, color: '#1d1d1f' },
  ],
  collaboration: {
    all: {
      eyebrow: '710 位总资源池',
      centerValue: '710',
      centerLabel: '总资源',
      note: '历史合作仅统计 2024—2025 去重达人；J200 当前合作单列。',
      items: [
        { label: '历史合作过', value: 88, share: 12.4, color: '#e60012' },
        { label: '其余资源', value: 622, share: 87.6, color: '#dedee3' },
      ],
    },
    internal: {
      eyebrow: '113 位在库资源',
      centerValue: '113',
      centerLabel: '在库资源',
      note: '在库资源包含历史合作与 J200 当前关系资源，并已按达人身份去重；历史合作为其中 88 位。',
      items: [
        { label: '历史合作过', value: 88, share: 77.9, color: '#e60012' },
        { label: '其余在库资源', value: 25, share: 22.1, color: '#dedee3' },
      ],
    },
  },
  smartHomeBrands: [
    { label: 'SwitchBot', value: 9, share: 32.1, color: '#e60012' },
    { label: 'Dreame', value: 6, share: 21.4, color: '#1d1d1f' },
    { label: 'Roborock', value: 5, share: 17.9, color: '#515154' },
    { label: 'Aqara', value: 4, share: 14.3, color: '#747478' },
    { label: 'Eufy', value: 3, share: 10.7, color: '#9c9ca1' },
    { label: 'Xiaomi', value: 3, share: 10.7, color: '#b5b5ba' },
  ],
}

export const performanceTiers = [
  { label: '5千–5万', historyCreators: 40, historyAvg: 24793, historyMedian: 13000, historyFee: 172411, externalCreators: 195, externalAvg: 18027, externalMedian: 6769, coreSample: 11, externalFee: 216.82 },
  { label: '5万–30万', historyCreators: 36, historyAvg: 52299, historyMedian: 15258, historyFee: 386427, externalCreators: 182, externalAvg: 63141, externalMedian: 28376, coreSample: 12, externalFee: 712.08 },
  { label: '30万–100万', historyCreators: 5, historyAvg: 110153, historyMedian: 45502, historyFee: 706849, externalCreators: 164, externalAvg: 242658, externalMedian: 93420, coreSample: 6, externalFee: 1616.67 },
  { label: '100万+', historyCreators: 2, historyAvg: 41702, historyMedian: 41702, historyFee: 1950000, externalCreators: 96, externalAvg: 434090, externalMedian: 238940, coreSample: 1, externalFee: 3100 },
]

export const historyData = {
  dedupedCreators: 88,
  crossYearRepeat: 19,
  years: [
    {
      year: '2024', label: '历史合作', creators: 50, publications: 74,
      paid: 49, exchange: 24, unknown: 1, fee: 16496004, currency: 'JPY',
      views: 2495003, avgViews: 34178, medianViews: 9863, maxViews: 700000,
      coverage: '73 / 74', peakCreator: 'luna',
    },
    {
      year: '2025', label: '历史合作', creators: 57, publications: 90,
      paid: 62, exchange: 28, unknown: 0, fee: 22856982.69, currency: 'JPY',
      views: 4153262, avgViews: 46147, medianViews: 16500, maxViews: 433660,
      coverage: '90 / 90', peakCreator: 'けんた',
    },
    {
      year: '2026', label: 'J200 当前合作', creators: 37, publications: 37,
      paid: 12, exchange: 25, unknown: 0, fee: 16443, currency: 'USD',
      views: 4685057, avgViews: 212957, medianViews: null, maxViews: 4170000,
      coverage: '22 / 37', peakCreator: 'はな',
    },
  ],
}

export const j200Data = {
  status: '进行中',
  effectiveCreators: 37,
  composition: [
    { label: '众筹期有效', value: 29, color: '#1d1d1f' },
    { label: '正式上市付费已发', value: 6, color: '#e60012' },
    { label: '正式上市置换', value: 2, color: '#8e8e93' },
  ],
  cooperationTypes: [
    { label: '已知付费', value: 12, color: '#e60012' },
    { label: '免费／置换', value: 25, color: '#1d1d1f' },
  ],
  views: 4685057,
  exposureCoverage: 22,
  averageViews: 212957,
  maxViews: 4170000,
  maxCreator: 'はな',
  crowdfunding: {
    creators: 29, paid: 6, exchange: 23, unknown: 0,
    exposure: 4323030, exposureCoverage: 14, averageViews: 308788,
    maxViews: 4170000, maxCreator: 'はな', confirmedFeeJpy: 1169000,
    confirmedFeeUsd: 7793,
    confirmedPayments: 6,
  },
  launch: {
    creators: 8, paid: 6, exchange: 2, unknown: 0,
    exposure: 362027, exposureCoverage: 8, averageViews: 45253,
    maxViews: 265011, maxCreator: 'いいもの図鑑', confirmedFeeUsd: 8650,
    confirmedPayments: 6, paidExposure: 360090, exchangeExposure: 1937, period: '2026.06.19—07.08',
    paidCreators: [
      { name: 'いいもの図鑑', views: 265011, contents: 3, url: 'https://www.youtube.com/shorts/czhf29Q0SxM' },
      { name: 'すぐる@iPhone・ガジェット', views: 37355, contents: 3, url: 'https://www.youtube.com/shorts/lJZ7XOCVwdU' },
      { name: '美咲みさ / 自作PC 女子', views: 31770, contents: 1, url: 'https://www.youtube.com/shorts/gYT08IEUGLk' },
      { name: 'あまと ガジェットのある暮らし', views: 13709, contents: 3, url: 'https://www.youtube.com/shorts/6Kl8yX8Oj4c' },
      { name: 'あす ┊︎ 快適な1人暮らし計画🍵', views: 8958, contents: 3, url: 'https://youtube.com/shorts/8zvelib3KhE' },
      { name: '岡ちゃんnel', views: 3287, contents: 1, url: 'https://www.youtube.com/watch?v=8jcAwxFapW4' },
    ],
    exchangeCreators: [
      { name: 'T.K TV', followers: 5660, avgViews: 3095, views: 1730, contents: 1, interactions: 24, url: 'https://www.youtube.com/shorts/dUKtfXpXGM0' },
      { name: '快適ライフ【便利で快適な生活】', followers: 4720, avgViews: 2520, views: 207, contents: 1, interactions: 4, url: 'https://youtu.be/NYlUssAXm_Y' },
    ],
  },
  paused: 7,
}

export const excellentCases = [
  {
    id: '2024-luna', creator: 'luna', year: 2024, project: '2024 年度合作',
    cooperationType: '付费', fee: 330000, currency: 'JPY', exposure: 700000,
    image: './cases/2024-luna.jpg', platform: 'TikTok',
    title: '智能视频门铃 G4 · 独居防犯场景',
    url: 'https://www.tiktok.com/@luna___room___/video/7427433853041528071',
    insight: '付费合作，70万曝光；以独居女性门口安全切入，场景直观；互动明细未回填。',
  },
  {
    id: '2025-kenta', creator: 'けんた', year: 2025, project: 'PFD sales campaign',
    cooperationType: '付费', fee: 250000, currency: 'JPY', exposure: 433660,
    image: './cases/2025-kenta.jpg', platform: 'YouTube', title: '防犯对策短视频',
    url: 'https://www.youtube.com/shorts/9HkKTX27qVc',
    insight: '付费合作，43.4万曝光；用防犯问题强开场，信息密度高；互动明细未回填。',
  },
  {
    id: '2025-pey', creator: 'ぺい', year: 2025, project: 'PFD sales campaign',
    cooperationType: '付费', fee: 300000, currency: 'JPY', exposure: 405869,
    image: './cases/2025-pey.jpg', platform: 'YouTube', title: '一人暮らし · 智能门铃场景',
    url: 'https://www.youtube.com/shorts/sx6RLyqeqXA',
    insight: '付费多平台合作，40.6万曝光；从独居门铃痛点给出快速解决方案；互动明细未回填。',
  },
  {
    id: '2026-j200-hana', creator: 'はな｜3児ママの子育て', year: 2026, project: 'J200 众筹期',
    cooperationType: '置换', fee: 0, exposure: 4170000,
    image: './cases/2026-j200-hana.jpg', imageClass: 'case-capture-hana', platform: 'Instagram', title: '家庭育儿场景破圈',
    url: 'https://www.instagram.com/reel/DV8dvNrCWDD/',
    insight: '众筹期合作，417万曝光、1.5万赞；孩子无钥匙进门引发家庭共鸣，评论聚焦兼容、安全与续航。',
  },
  {
    id: '2026-j200-iimono', creator: 'いいもの図鑑', year: 2026, project: 'J200 正式上市',
    cooperationType: '付费', fee: 255000, currency: 'JPY', exposure: 265011,
    image: './cases/2026-j200-iimono.jpg', platform: 'YouTube', title: 'J200 正式上市 · 多平台短视频',
    url: 'https://www.youtube.com/shorts/czhf29Q0SxM',
    insight: '正式上市付费合作，三平台26.5万曝光；突出手机即钥匙的日常便利；累计互动约3500+。',
  },
  {
    id: '2026-j200-mame', creator: 'マメ', year: 2026, project: 'J200 众筹期',
    cooperationType: '付费', fee: 937500, currency: 'JPY', exposure: 33000,
    image: './cases/2026-j200-mame.jpg', platform: 'YouTube', title: 'J200 长视频实测',
    url: 'https://www.youtube.com/watch?v=5a5a-SYnUBE',
    insight: '众筹期付费长视频，3.3万曝光；完整实测安装与多种解锁方式，适合深度种草；互动明细未回填。',
  },
]

export const headCreators = [
  {
    id: 'kazu', name: 'カズチャンネル / Kazu Channel', avatar: './avatars/head/kazu.jpg',
    url: 'https://www.youtube.com/channel/UCVPz_nauEJpqPxxvYiOpCHQ', followers: 1840000,
    avgViews: 105353, medianViews: 74521, brandAvgViews: 247655,
    quoteStatus: '待正式询价', budgetRange: '$30k–50k', relationship: '外部候选',
    recommendation: '优先询价',
    description: '智能锁、SwitchBot 与整屋智能家居内容积累完整，题材与 J200 直接匹配；尚无 Aqara 合作记录，适合首轮询价验证。',
    evidence: [
      { brand: 'SADIOT LOCK', views: 601069 },
      { brand: 'SwitchBot Lock Pro', views: 392678 },
      { brand: 'SwitchBot Lock Ultra', views: 148566 },
    ],
  },
  {
    id: 'koji', name: '瀬戸弘司 / Koji Seto', avatar: './avatars/head/koji.png',
    url: 'https://www.youtube.com/channel/UCFBjsYvwX7kWUjQoW7GcJ5A', followers: 1680000,
    avgViews: 184744, medianViews: 155401, brandAvgViews: 189218,
    quoteStatus: '待正式询价', budgetRange: '$25k–45k', relationship: '外部候选',
    recommendation: '品牌背书备选',
    description: 'Apple 内容积累深，受众与 Apple Home / Wallet 叙事契合；更适合可信体验与品牌背书，不预设爆量。',
    evidence: [
      { brand: 'SwitchBot 实际使用', views: 70487 },
      { brand: 'SwitchBot 实际使用', views: 37136 },
    ],
  },
]

export const koreaReference = {
  name: 'ITSub잇섭', followers: 2830000, budget: '约 $50k',
  title: '韩国头部达人合作参考',
  description: 'Aqara 智能锁内容带来显著增长，具体销量归因未单独拆分。该案例仅用于校准头部合作的预算与影响力预期，不直接作为日本市场销量预测。',
  url: 'https://www.youtube.com/@ITSUB', avatar: './cases/itsub-avatar.jpg',
  videos: [
    {
      title: 'iPhone、Apple Watch 与指纹 0.5 秒解锁', views: 960000,
      image: './cases/itsub-aqara-k100.jpg', url: 'https://www.youtube.com/watch?v=LUQuLJYFjig', product: 'Aqara K100',
    },
    {
      title: 'iPhone 与 Galaxy 均可使用的智能门锁', views: 660000,
      image: './cases/itsub-aqara-l100.jpg', url: 'https://www.youtube.com/watch?v=6YkWjNcb7D4', product: 'Aqara L100',
    },
  ],
}

export const methodologyNotes = [
  '达人资源总量 710 = 历史有记录的在库达人 113 + 第三方平台外部初筛达人 597；外部由 666 个平台账号纠错合并为 637 位身份，再严格匹配在库 40 位。',
  '外部 637 位属于供给初筛，不代表全部已人工验证、可联系或已完成商务确认；达人类型为自动互斥初分。',
  'Apple 垂类分开统计：在库 25 / 113，外部初筛达人 44 / 597；外部全池为 61 / 637。',
  '历史费用为 2024—2025 tracker 原始 JPY 记录；J200 费用统一以 USD 展示，其中众筹期日元费用按固定汇报汇率 1 USD = 150 JPY 换算。',
  '智能家居品牌仅审计 28 位后期可考虑合作资源；公开未检出不代表从未合作，品牌可多选，比例不可相加。',
  'J200 当前 37 位中，付费 12 位、置换 25 位；众筹期无费用记录的合作均按置换统计。15 位尚无曝光记录。众筹期已确认现金费用 JPY 1,169,000 按固定汇报汇率 1 USD = 150 JPY 换算为约 USD 7,793，正式上市期为 USD 8,650，合计约 USD 16,443。优秀案例中，はな为置换，いいもの図鑑原始报价 USD 1,700，卡片按同一固定汇率折算为 JPY 255,000。',
]
